import React, { useCallback } from "react";
import useMeasure from "react-use-measure";
import { useSpring, animated } from "@react-spring/web";
import cx from "classnames";

import styles from "./transcripts.module.scss";
import { formatTime } from "src/pages/coaching/manage/podcasts/edit/helper";
import { PodcastTranscripts } from "src/types/coaching/podcast";
import _ from "lodash";

interface PodcastTranscriptsProps {
  className?: string;
  loading?: boolean;
  transcripts: PodcastTranscripts;
  // eslint-disable-next-line no-unused-vars
  onExpand?: (value: boolean) => void;
}

export const PodcastTranscriptsContainer: React.FC<PodcastTranscriptsProps> = ({
  className, loading, transcripts
}) => {
  return (
    <div className={cx(styles.transcriptContainer, className)}>
      <div className={styles.transcripts}>
        {loading && (
          _.times(5, (index) => (
            <PodcastTranscriptRowPlaceholder key={index} />
          ))
        )}

        {(!loading && transcripts?.topicSections || []).map((transcript, index) => {
          return (transcript.conversations || []).map(
            (conversation) => {
              return (
                <div key={conversation.id} className={styles.transcript}>
                  {conversation.text}
                </div>
              );
            },
          );
        })}
      </div>
    </div>
  );
};

export const PodcastTranscriptRowPlaceholder: React.FC = () => {
  return (
    <div className={cx(styles.transcript, styles.placeholder)}>
      <div className={cx(styles.text, styles.block)}></div>
      <div className={cx(styles.text, styles.block)}></div>
      <div className={cx(styles.text, styles.block)}></div>
    </div>
  );
}
